import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from './context/AuthContext';

import Header from './components/Header';
import Hero from './components/Hero';
import Mission from './components/Mission';
import Divisions from './components/Divisions';
import EligiblSubsidies from './components/EligiblSubsidies';
import Footer from './components/Footer';

import ResearchCatalogue from './pages/research/ResearchCatalogue';
import PaperReader from './pages/research/PaperReader';
import AdminEditor from './pages/admin/AdminEditor';
import ProductsHub from './pages/products/ProductsHub';
import SearchUpPage from './pages/products/SearchUpPage';
import TrendScanPage from './pages/products/TrendScanPage';
import WalletKingPage from './pages/products/WalletKingPage';
import SecurityQuote from './pages/security/SecurityQuote';
import ConsultingPage from './pages/consulting/ConsultingPage';
import AIAutomationService from './pages/consulting/AIAutomationService';
import SoftwareEngineeringService from './pages/consulting/SoftwareEngineeringService';
import DataAnalyticsService from './pages/consulting/DataAnalyticsService';
import CRMOperationsService from './pages/consulting/CRMOperationsService';
import BlogListing from './pages/blog/BlogListing';
import BlogArticle from './pages/blog/BlogArticle';
import BlogAdmin from './pages/blog/BlogAdmin';
import BlogEditor from './pages/blog/BlogEditor';
import WritingDashboard from './pages/admin/WritingDashboard';
import UsageDashboard from './pages/admin/UsageDashboard';
import CRMDashboard from './pages/admin/CRMDashboard';
import CareersPage from './pages/careers/CareersPage';
import PrivacyPolicy from './pages/legal/PrivacyPolicy';
import TermsConditions from './pages/legal/TermsConditions';
import AdminRoute from './components/AdminRoute';
import useAnalyticsTracker from './hooks/useAnalyticsTracker';

/* Home — the original landing page */
function HomePage() {
  return (
    <>
      <Hero />
      <Mission />
      <Divisions />
      <EligiblSubsidies />
    </>
  );
}

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

function AppContent() {
  useAnalyticsTracker();
  return (
    <div className="App">
      <Header />

      <Routes>
        {/* Landing */}
        <Route path="/" element={<HomePage />} />

        {/* Research */}
        <Route path="/research" element={<ResearchCatalogue />} />
        <Route path="/research/:id" element={<PaperReader />} />

        {/* Admin — requires alvarezjd404@gmail.com */}
        <Route path="/admin" element={<AdminRoute><WritingDashboard /></AdminRoute>} />
        <Route path="/admin/new" element={<AdminRoute><AdminEditor /></AdminRoute>} />
        <Route path="/admin/edit/:id" element={<AdminRoute><AdminEditor /></AdminRoute>} />

        {/* Products */}
        <Route path="/products" element={<ProductsHub />} />
        <Route path="/products/searchup" element={<SearchUpPage />} />
        <Route path="/products/trendscan" element={<TrendScanPage />} />
        <Route path="/products/wallet-king" element={<WalletKingPage />} />
        <Route path="/products/mecash" element={<Navigate to="/products/wallet-king" replace />} />
        <Route path="/security" element={<SecurityQuote />} />

        {/* Consulting */}
        <Route path="/consulting" element={<ConsultingPage />} />
        <Route path="/consulting/ai-automation" element={<AIAutomationService />} />
        <Route path="/consulting/software-engineering" element={<SoftwareEngineeringService />} />
        <Route path="/consulting/data-analytics" element={<DataAnalyticsService />} />
        <Route path="/consulting/crm-operations" element={<CRMOperationsService />} />

        {/* Careers */}
        <Route path="/careers" element={<CareersPage />} />

        {/* Blog / Engineering Log */}
        <Route path="/blog" element={<BlogListing />} />
        <Route path="/blog/:slug" element={<BlogArticle />} />

        {/* Blog Admin */}
        <Route path="/admin/blog" element={<AdminRoute><BlogAdmin /></AdminRoute>} />
        <Route path="/admin/blog/new" element={<AdminRoute><BlogEditor /></AdminRoute>} />
        <Route path="/admin/blog/edit/:id" element={<AdminRoute><BlogEditor /></AdminRoute>} />

        {/* Admin Dashboards */}
        <Route path="/admin/analytics" element={<AdminRoute><WritingDashboard /></AdminRoute>} />
        <Route path="/admin/writing" element={<AdminRoute><WritingDashboard /></AdminRoute>} />
        <Route path="/admin/usage" element={<AdminRoute><UsageDashboard /></AdminRoute>} />
        <Route path="/admin/crm" element={<AdminRoute><CRMDashboard /></AdminRoute>} />

        {/* Legal */}
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsConditions />} />
      </Routes>

      <Footer />
    </div>
  );
}

function App() {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
    <BrowserRouter>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </BrowserRouter>
    </GoogleOAuthProvider>
  );
}

export default App;
